import { IconProps } from "./dto"
export function AttachmentIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 16 20" fill="none">
            <path d="M9.66667 1.66663H3C2.55798 1.66663 2.13405 1.84222 1.82149 2.15478C1.50893 2.46734 1.33334 2.89127 1.33334 3.33329V16.6666C1.33334 17.1087 1.50893 17.5326 1.82149 17.8451C2.13405 18.1577 2.55798 18.3333 3 18.3333H13C13.442 18.3333 13.866 18.1577 14.1785 17.8451C14.4911 17.5326 14.6667 17.1087 14.6667 16.6666V6.66663M9.66667 1.66663L14.6667 6.66663M9.66667 1.66663V6.66663H14.6667M8 15V9.99996M5.5 12.5H10.5" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
